// Updated Exit Interview Checklist with grouping, checkboxes, remarks, and final approval

import React from 'react';
import { Grid, Checkbox, FormControlLabel, TextField, Typography, MenuItem, Select, InputLabel, FormControl, Divider } from '@mui/material';

const ExitInterviewChecklist = ({ formData, setFormData }) => {

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <>
      {/* <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>Checklist for Exit Interview</Typography> */}

      {/* Company Assets */}
      <Typography variant="subtitle1" sx={{ mt: 1 }}>Company Assets</Typography>
      <Grid container spacing={2}>
        {[
          { label: 'Company vehicle handed in', field: 'vehicleHandedIn' },
          { label: 'All equipment handed in', field: 'equipmentHandedIn' },
          { label: 'All library book submitted', field: 'libraryBooksSubmitted' },
          { label: 'ID card / Access card returned', field: 'accessCardReturned' }
        ].map(({ label, field }) => (
          <React.Fragment key={field}>
            <Grid item xs={12} sm={6} md={4}>
              <FormControlLabel
                control={<Checkbox color='secondary' checked={formData[field] || false} onChange={(e) => handleChange(field, e.target.checked)} />}
                label={label}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={8}>
              <TextField fullWidth size="small" label="Remarks" value={formData[`${field}_remarks`] || ''} onChange={(e) => handleChange(`${field}_remarks`, e.target.value)} />
            </Grid>
          </React.Fragment>
        ))}
      </Grid>

      {/* HR Formalities */}
      <Typography variant="subtitle1" sx={{ mt: 3 }}>HR Formalities</Typography>
      <Grid container spacing={2}>
        {[
          { label: 'Exit interview conducted', field: 'interviewConducted' },
          { label: 'Resignation letter submitted', field: 'resignationSubmitted' },
          { label: 'NDA signed (if applicable)', field: 'ndaSigned' },
          { label: 'PF withdrawal form submitted', field: 'pfFormSubmitted' },
          { label: 'Gratuity form submitted', field: 'gratuityFormSubmitted' }
        ].map(({ label, field }) => (
          <React.Fragment key={field}>
            <Grid item xs={12} sm={6} md={4}>
              <FormControlLabel
                control={<Checkbox color='secondary' checked={formData[field] || false} onChange={(e) => handleChange(field, e.target.checked)} />}
                label={label}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={8}>
              <TextField fullWidth size="small" label="Remarks" value={formData[`${field}_remarks`] || ''} onChange={(e) => handleChange(`${field}_remarks`, e.target.value)} />
            </Grid>
          </React.Fragment>
        ))}
      </Grid>

      {/* Security & IT Access */}
      <Typography variant="subtitle1" sx={{ mt: 3 }}>Security & IT Access</Typography>
      <Grid container spacing={2}>
        {[
          { label: 'System access revoked', field: 'systemAccessRevoked' },
          { label: 'Email account deactivated', field: 'emailDeactivated' },
          { label: 'Biometric disabled', field: 'biometricDisabled' }
        ].map(({ label, field }) => (
          <React.Fragment key={field}>
            <Grid item xs={12} sm={6} md={4}>
              <FormControlLabel
                control={<Checkbox color='secondary' checked={formData[field] || false} onChange={(e) => handleChange(field, e.target.checked)} />}
                label={label}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={8}>
              <TextField fullWidth size="small" label="Remarks" value={formData[`${field}_remarks`] || ''} onChange={(e) => handleChange(`${field}_remarks`, e.target.value)} />
            </Grid>
          </React.Fragment>
        ))}
      </Grid>

      {/* Final Approval Section */}
      <Divider sx={{ mt: 4, mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth size="small">
            <InputLabel>Final Exit Approved By</InputLabel>
            <Select
              value={formData.finalApprovedBy || ''}
              label="Final Exit Approved By"
              onChange={(e) => handleChange('finalApprovedBy', e.target.value)}
            >
              <MenuItem value="HR">HR</MenuItem>
              <MenuItem value="Admin">Admin</MenuItem>
              <MenuItem value="Manager">Manager</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <FormControlLabel
            control={<Checkbox color='secondary' checked={formData.finalExitConfirmed || false} onChange={(e) => handleChange('finalExitConfirmed', e.target.checked)} />}
            label="Confirm Final Exit"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ExitInterviewChecklist;
